import jsYaml from "js-yaml";

export function createDotGitHubActions() {
	return {
		prepare: {
			"action.yml": jsYaml
				.dump({
					description: "Prepares the repo for a typical CI job",
					name: "Prepare",
					runs: {
						steps: [
							{ uses: "pnpm/action-setup@v2" },
							{
								uses: "actions/setup-node@v3",
								with: { cache: "pnpm", "node-version": "18" },
							},
							{
								run: "pnpm install --frozen-lockfile",
								shell: "bash",
							},
						],
						using: "composite",
					},
				})
				.replaceAll(/\n(\S)/g, "\n\n$1"),
		},
	};
}
